import React, { Component } from 'react';
import { IconButton } from './IconButton';
import { connect } from 'react-redux';
import { DuplicateIconNew, copyIcon } from '../../../style/images';
import { translate } from '../../services';
import { PropTypes } from 'prop-types';
import { cartDispatcher, productsDispatcher } from '../../store';

export class CloneButtonComponent extends Component {
  cloneToCart = () => {
    const { onClick, product } = this.props;
    onClick && onClick();
    // Need to send the MP+FP configuration present in product.additionalProducts[0] for correct cloning
    // in case of SuperConfiguration (MP+FP), currently it is not working at the SuperConfiguration level.
    //Hence disabling it at SuperConfiguration level
    //const productToClone = (product.isSuperConfiguration && product.additionalProducts[0]) || product;
    this.props.cloneInCart( {product,amount: 1} );
  }

  render() {
    const { disabled, hidden, icon } = this.props;

    return <IconButton
      className="round-button"
      tooltip={ translate( 'Clone cart item' ) }
      icon={ icon?icon:DuplicateIconNew } 
      onClick={ this.cloneToCart } 
      disabled={ disabled }
      hidden={ hidden }
    />;
  }
}

CloneButtonComponent.propTypes = {
  cloneInCart: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hidden: PropTypes.bool,
  onClick: PropTypes.func,
  product: PropTypes.shape( {} ).isRequired,
};

export const CloneButton = connect( null, cartDispatcher )( CloneButtonComponent );